const categories = [
  'news',
  'jobs',
  'tools',
  'videos',
  'tutorials',
  'opensource'
];

export default categories;
